import permissions from '../../permissions'

const REGULATION_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.VISUALIZE,
    tag: permissions.REGULATIONS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.REGULATIONS.MANAGE,
  },
]

export default REGULATION_LIST
